<script setup lang="ts">
import { ref } from "vue";
import { connectRecord } from "../actions/connectRecord";
import { activeRoomState } from "../states/active_room";
import { roomState, updateLocalRoom } from "../states/room";
import { ws_instance } from "../websocket/ws-instance";
import { viewState } from "../states/viewState";
import RightBlockWrapper from "../components/rightBlock/RightBlockWrapper.vue";
import ScreenShareArea from "./room/newAreas/ScreenShareArea.vue";
import SpeakerMode from "./room/newAreas/SpeakerMode.vue";
import ShareSpeakerNew from "../components/ShareSpeakerNew.vue";
import { isRecorder } from "../states/isRecState";
// import ReactionButton from "../components/room/bar_items/ReactionButton.vue";

isRecorder.value = true;

const props = defineProps<{
  roomId: string;
}>();
const connected = ref(false);
async function init() {
  await ws_instance.connect(props.roomId, true);
  if (!roomState.id) {
    await updateLocalRoom(props.roomId).catch(() => {});
  }
  await connectRecord();
  connected.value = true;
}
init();
</script>
<template>
  <div class="active-room-container">
    <div class="speaker-container">
      <ShareSpeakerNew
        v-if="
          activeRoomState.mode === 'stream' &&
          viewState.showSpeakerInDemo
        "
        :has-move="false"
      />
      <div class="left-block">
        <div class="main-content"></div>
        <!-- До лучших времен -->
        <!-- <div class="reaction-block"> -->
        <!--   <ReactionButton recorder /> -->
        <!-- </div> -->
      </div>
      <div
        class="right-block-spacer"
        :class="{
          opened: true,
        }"
      ></div>
      <div
        class="right-block animated"
        :class="{
          opened: true,
        }"
      >
        <div
          class="spacer"
          :class="{
            opened:
              activeRoomState.mode === 'stream' &&
              viewState.showSpeakerInDemo
          }"
        ></div>
        <RightBlockWrapper />
      </div>
    </div>
    <div ref="leftBlockEl" class="left-block">
      <div class="main-content">
        <div v-if="!connected"></div>
        <ScreenShareArea v-else-if="activeRoomState.mode === 'stream'" />
        <SpeakerMode v-else />
      </div>
    </div>
    <div
      class="right-block-spacer"
      :class="{
        opened: true,
      }"
    ></div>
  </div>
</template>
<style scoped>
.active-room-container {
  width: 100vw;
  height: 100dvh;
  display: flex;
  background-color: #1e1818;
  background-image: var(--bg-image);
  background-repeat: repeat;
  position: relative;
  overflow: hidden;
}

.active-room-container .reaction-block {
  padding: 8px;
  display: flex;
}

.active-room-container .left-block {
  height: 100%;
  width: 100px;
  flex-grow: 1;
  display: flex;
  flex-direction: column;
  position: relative;
}

.active-room-container .left-block .main-content {
  width: 100%;
  height: 100px;
  flex-grow: 1;
}

.active-room-container .right-block-spacer {
  transition: width 0.3s ease-in-out;
  height: 100%;
}

.active-room-container .right-block {
  transition: transform 0.3s ease-in-out;
  padding: 8px 8px 8px 0;
  position: absolute;
  top: 0;
  bottom: 0;
  right: 0px;
  display: flex;
  flex-direction: column;
}

@media screen and (min-width: 811px) {
  .active-room-container .right-block-spacer {
    width: 0px;
  }
  .active-room-container .right-block-spacer.opened:not(.floating) {
    width: 367px;
  }
  .active-room-container .right-block {
    width: 367px;
    transform: translateX(367px);
  }
  .active-room-container .right-block.opened {
    transform: translateX(0px);
  }
}

@media screen and (max-width: 810px) {
  .active-room-container .right-block-spacer {
    width: 0px;
    height: 100%;
  }
  .active-room-container .right-block {
    position: absolute;
    top: 12px;
    left: 12px;
    right: 12px;
    bottom: 68px;
    z-index: 30;
    transform: translateY(100%);
    z-index: 30;
  }

  .active-room-container .right-block.opened {
    transform: translateY(0px);
  }
}

.spacer {
  width: 356px;
  height: 0px;
  transition: height 0.3s ease-in-out;
  flex-shrink: 0;
  pointer-events: none;
}

.spacer.opened {
  height: 208.25px;
}

.speaker-container {
  position: absolute;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  display: flex;
  pointer-events: none;
  z-index: 20;
}

.speaker-container > * {
  pointer-events: auto;
}

.speaker-container .left-block {
  pointer-events: none;
}

.speaker-container .right-block {
  pointer-events: none;
}

.speaker-container .main-content * {
  pointer-events: auto;
}

.speaker-container .right-block * {
  pointer-events: auto;
}

.right-block-spacer {
  pointer-events: none !important;
}
</style>
